/** @format */


export const Avatar = props => {
  return (
    <>
      <div className={`avatarBox ${props.loading ? `avatarBox-loading` : ``}`}>
        {props.srcImg !== '' ? (
          <img src={props.srcImg} alt="Avatar" />
        ) : (
          <span className="avatarBox__firstLetter">{props.name.charAt(0)}</span>
        )}
      </div>
    </>
  );
};
